import { Component } from 'react';
import { GroupControl } from '../../../../GroupField';
import ModelField from '../Field';
import ModelControl from '../Control';

export default class ModelGroupField extends Component {
  render() {
    return (
      <ModelField
        {...this.props}
        component={GroupControl}
        FormControl={ModelControl}
      />
    );
  }
}
